import React, { Component } from 'react'
import PropTypes from 'prop-types'
import v4 from 'uuid/v4'

import AgendaSingleItemDatesListItem from "./AgendaSingleItemDatesListItem"


class AgendaSingleItemDatesList extends Component {
	constructor(props, context) {
		super(props, context);

		// Calculate initial values before initializing state
		let initialMonth = 1
		let hasInitError = false
		let initErrorMessage = null
		let minMonth = 1
		let maxMonth = 12

		// Safely parse dates_list with error handling
		try {
			if (this.props.postItem &&
				this.props.postItem._source &&
				this.props.postItem._source.dates_list) {
				const datesListString = this.props.postItem._source.dates_list.toString()
				if (datesListString) {
					const decodedString = atob(datesListString)
					const parsedDates = JSON.parse(decodedString)

					if (parsedDates &&
						Array.isArray(parsedDates) &&
						parsedDates.length > 0 &&
						parsedDates[0] &&
						Array.isArray(parsedDates[0]) &&
						parsedDates[0].length > 0 &&
						parsedDates[0][0] &&
						parsedDates[0][0].month) {

						const firstMonth = Number(parsedDates[0][0].month)
						const lastMonth = Number(parsedDates[0][parsedDates[0].length - 1]?.month || firstMonth)

						initialMonth = firstMonth
						minMonth = firstMonth
						maxMonth = lastMonth
					}
				}
			}
		} catch (error) {
			console.error("Error initializing AgendaSingleItemDatesList:", error)
			hasInitError = true
			initErrorMessage = "Erreur lors du chargement des dates"
		}

		// Initialize state with calculated values
		this.state = {
			currentMonth: initialMonth,
			hasError: hasInitError,
			errorMessage: initErrorMessage
		}

		this.minMonth = minMonth
		this.maxMonth = maxMonth
	}

	calendarOnClickPrev = () => {
		try {
			let current = document.querySelector('.agenda-single-calendar-month.current')
			let prev = null
			if (current) {
				const currentClass = current.getAttribute('class') || ''
				const monthMatch = currentClass.match(/month-item-(\d+)/)
				if (monthMatch) {
					prev = Number(monthMatch[1]) - 1
					if (prev < 1) {
						const monthElements = document.querySelectorAll('.agenda-single-calendar-month')
						prev = monthElements.length
					}
				}
			}

			if (prev) {
				const currentElement = document.querySelector('.agenda-single-calendar-month.current')
				const prevElement = document.querySelector('.agenda-single-calendar-month.month-item-' + prev)

				if (currentElement && prevElement) {
					currentElement.classList.remove('current')
					prevElement.classList.add('current')
				}
			}
		} catch (error) {
			console.error("Error in calendarOnClickPrev:", error)
		}
	}

	calendarOnClickNext = () => {
		try {
			let current = document.querySelector('.agenda-single-calendar-month.current')
			let next = null
			if (current) {
				const currentClass = current.getAttribute('class') || ''
				const monthMatch = currentClass.match(/month-item-(\d+)/)
				if (monthMatch) {
					next = Number(monthMatch[1]) + 1
					const monthElements = document.querySelectorAll('.agenda-single-calendar-month')
					if (next > monthElements.length) {
						next = 1
					}
				}
			}

			if (next) {
				const currentElement = document.querySelector('.agenda-single-calendar-month.current')
				const nextElement = document.querySelector('.agenda-single-calendar-month.month-item-' + next)

				if (currentElement && nextElement) {
					currentElement.classList.remove('current')
					nextElement.classList.add('current')
				}
			}
		} catch (error) {
			console.error("Error in calendarOnClickNext:", error)
		}
	}

	handleKeyDown = (event, direction) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			if (direction === 'prev') {
				this.calendarOnClickPrev()
			} else if (direction === 'next') {
				this.calendarOnClickNext()
			}
		}
	}

	getPostDatesList = () => {
		const datesList = []
		try {
			if (this.props.postItem &&
				this.props.postItem._source &&
				this.props.postItem._source.dates_list) {

				let json = this.props.postItem._source.dates_list.toString()
				if (!json) {
					return datesList
				}

				let dateStart = null
				let monthIndex = null
				let dayIndex = null
				let yearIndex = null

				json = JSON.parse(atob(json))
				if (!Array.isArray(json)) {
					return datesList
				}

				json.forEach((dateNivOne, indexOne) => {
					if (Array.isArray(dateNivOne)) {
						dateNivOne.forEach((dateNivTwo, indexTwo) => {
							try {
								if (dateNivTwo && dateNivTwo.date && Array.isArray(dateNivTwo.date) && dateNivTwo.date[0]) {
									dateStart = new Date(dateNivTwo.date[0] * 1000)

									// Validate date
									if (isNaN(dateStart.getTime())) {
										return
									}

									monthIndex = Number(dateNivTwo.month)
									if (isNaN(monthIndex) || monthIndex < 1 || monthIndex > 12) {
										return
									}

									dayIndex = Number(Intl.DateTimeFormat('fr-FR', { day: '2-digit' }).format(dateStart))
									yearIndex = Number(Intl.DateTimeFormat('fr-FR', { year: 'numeric' }).format(dateStart))

									if (!(datesList[yearIndex] !== undefined)) {
										datesList[yearIndex] = []
									}
									if (!(datesList[yearIndex][monthIndex] !== undefined)) {
										datesList[yearIndex][monthIndex] = []
									}
									if (!datesList[yearIndex][monthIndex][dayIndex]) {
										datesList[yearIndex][monthIndex][dayIndex] = []
									}

									if (dateNivTwo.date[0]) {
										datesList[yearIndex][monthIndex][dayIndex].push(dateNivTwo.date[0])
									}
									if (dateNivTwo.date[1]) {
										datesList[yearIndex][monthIndex][dayIndex].push(dateNivTwo.date[1])
									}
								}
							} catch (dateError) {
								console.error("Error processing date:", dateError)
							}
						})
					}
				})
			}
		} catch (e) {
			console.error("Parsing error in getPostDatesList:", e)
			this.setState({
				hasError: true,
				errorMessage: "Erreur lors du traitement des dates"
			})
		}
		return datesList
	}

	getPostDatesListShowMonth = (month, monthList) => {
		try {
			if (!monthList || !Array.isArray(monthList) || monthList.length === 0) {
				return "Mois invalide"
			}

			let firstKey = 0
			monthList.forEach((element, index) => {
				if (firstKey === 0) {
					firstKey = index
				}
			})

			if (monthList[firstKey] && monthList[firstKey][0]) {
				const timestamp = monthList[firstKey][0]
				if (typeof timestamp === 'number' && !isNaN(timestamp)) {
					const date = new Date(timestamp * 1000)
					if (!isNaN(date.getTime())) {
						date.setMonth(month - 1)
						return Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(date)
					}
				}
			}

			return "Mois invalide"
		} catch (error) {
			console.error("Error in getPostDatesListShowMonth:", error)
			return "Mois invalide"
		}
	}

	getPostDatesListShowMonthList = (monthList) => {
		try {
			if (!monthList || !Array.isArray(monthList)) {
				return []
			}

			let start = null
			let startDay = null
			let end = null

			return monthList.map((week, index) => {
				try {
					const timeArray = []
					if (week && Array.isArray(week) && week.length > 0) {
						let hourIndex = 0
						let hourNewIndex = 0

						for (hourIndex = 0; hourIndex < week.length; hourIndex = hourIndex + 2) {
							try {
								if (week[hourIndex] && typeof week[hourIndex] === 'number' && !isNaN(week[hourIndex])) {
									start = new Date(week[hourIndex] * 1000)

									if (!isNaN(start.getTime())) {
										startDay = Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: '2-digit' }).format(start)

										if (!timeArray[hourNewIndex]) {
											timeArray[hourNewIndex] = []
										}

										timeArray[hourNewIndex][0] = String(Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' }).format(start)).replace(":", "h")

										if (week[hourIndex + 1] && typeof week[hourIndex + 1] === 'number' && !isNaN(week[hourIndex + 1])) {
											end = new Date(week[hourIndex + 1] * 1000)
											if (!isNaN(end.getTime())) {
												timeArray[hourNewIndex][1] = String(Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' }).format(end)).replace(":", "h")
											}
										}

										hourNewIndex++
									}
								}
							} catch (timeError) {
								console.error("Error processing time:", timeError)
							}
						}
					}

					if (startDay && timeArray.length > 0) {
						return <AgendaSingleItemDatesListItem key={index} startDay={startDay} timeArray={timeArray} />
					}

					return null
				} catch (weekError) {
					console.error("Error processing week:", weekError)
					return null
				}
			}).filter(Boolean) // Remove null entries
		} catch (error) {
			console.error("Error in getPostDatesListShowMonthList:", error)
			return []
		}
	}

	getPostDatesListShow = () => {
		try {
			const datesList = this.getPostDatesList()
			let cpt = 1

			if (datesList && datesList.length > 0) {
				return datesList.map((yearList, yearIndex) => {
					if (!yearList || !Array.isArray(yearList)) {
						return null
					}

					return yearList.map((month, monthIndex) => {
						if (!month || !Array.isArray(month)) {
							return null
						}

						try {
							const monthTitle = this.getPostDatesListShowMonth(monthIndex, month)
							const MonthList = this.getPostDatesListShowMonthList(month)

							if (!monthTitle || monthTitle === "Mois invalide" || MonthList.length === 0) {
								return null
							}

							let currentShow = 'agenda-single-calendar-month month-item-' + cpt

							if (this.state.currentMonth === monthIndex) {
								currentShow = 'agenda-single-calendar-month current month-item-' + cpt
							}

							cpt = cpt + 1

							return (
								<div className={currentShow} key={v4()}>
									<AgendaSingleItemDatesListItem
										monthTitle={monthTitle}
										OnClickPrev={this.calendarOnClickPrev}
										OnClickNext={this.calendarOnClickNext}
										itemRef={cpt}
									/>
									<div className="agenda-single-calendar-month-days">{MonthList}</div>
								</div>
							)
						} catch (monthError) {
							console.error("Error processing month:", monthError)
							return null
						}
					}).filter(Boolean) // Remove null entries
				}).filter(Boolean) // Remove null entries
			} else {
				return ''
			}
		} catch (error) {
			console.error("Error in getPostDatesListShow:", error)
			this.setState({
				hasError: true,
				errorMessage: "Erreur lors de l'affichage des dates"
			})
			return ''
		}
	}

	render = () => {
		// Show error state if there's an error
		if (this.state.hasError) {
			return (
				<div
					className="agenda-single-calendar agenda-single-calendar-error"
					role="alert"
					aria-live="polite"
					aria-label="Erreur de chargement des dates"
				>
					<div className="error-message">
						{this.state.errorMessage || "Erreur lors du chargement des dates"}
					</div>
				</div>
			)
		}

		// Check if we have valid data to render
		if (!this.props.postItem ||
			!this.props.postItem._source ||
			!this.props.postItem._source.dates_list) {
			return null
		}

		return (
			<div
				className="agenda-single-calendar"
				role="region"
				aria-label="Calendrier des événements"
				aria-describedby="calendar-description"
			>
				<div id="calendar-description" className="sr-only">
					Calendrier des événements avec navigation par mois
				</div>
				{this.getPostDatesListShow()}
			</div>
		)
	}
}

AgendaSingleItemDatesList.propTypes = {
	postItem: PropTypes.shape({
		_source: PropTypes.shape({
			dates_list: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.number
			])
		})
	})
}

AgendaSingleItemDatesList.defaultProps = {
	postItem: null
}

export default AgendaSingleItemDatesList;
